// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__2LRvr","sent":"Form_sent__44NYQ"};